import type { VariantLoadingSizeProps } from '../const';
import { cn } from '@utils';
import { forwardRef } from 'react';
import { getSizeClass, SR_LOADING_TEXT } from '../helper';
import '../index.less';

function CircularLoading({ className, size = 'md' }: VariantLoadingSizeProps, ref: React.Ref<HTMLDivElement>) {
  return (
    <div ref={ref} className={cn('wg-variant-loading__circular-spinner', getSizeClass(size), className)}>
      <span className="wg-variant-loading__sr-only">{SR_LOADING_TEXT}</span>
    </div>
  );
}

const CircularLoadingComponent = forwardRef<HTMLDivElement, VariantLoadingSizeProps>(CircularLoading);
CircularLoadingComponent.displayName = 'CircularLoading';

export default CircularLoadingComponent;
